import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import { useSelector } from "react-redux";

function ClasicAboutCeoMessage() {
  const [hospitalAbout, setHospitalAbout] = useState({});
  const [expanded, setExpanded] = useState(false);
  const truncateLength = 770;
  const siteData = useSelector((store) => store.global.loginData);

  useEffect(() => {
    getHospitalAboutData();
  }, []);

  const getHospitalAboutData = async () => {
    try {
      const response = await SendPostRequest("content/aboutus");
      if (response?.data) {
        setHospitalAbout(response.data);
      }
    } catch (error) {
      console.error("Error fetching hospital about data:", error);
    }
  };

  const createMarkup = (html) => {
    return { __html: html };
  };

  const shouldTruncate =
    hospitalAbout?.ceo_description?.length > truncateLength;
  const displayContent = expanded
    ? hospitalAbout?.ceo_description
    : shouldTruncate
      ? truncateText(hospitalAbout?.ceo_description, truncateLength)
      : hospitalAbout?.ceo_description;

  function truncateText(text, maxLength) {
    if (!text) return "";
    return text.slice(0, maxLength) + "...";
  }


  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      {hospitalAbout?.ceo_description && hospitalAbout?.ceo_image && (
        <div id="section-about" className="section-about pt-4" style={{paddingBottom:isMobile ? "0" : "1.5rem"}}>
          <div className="container">
            <div className="row d-flex align-items-center mb-4 animated fadeInLeft visible">
              <div className="col-lg-6" data-animation="fadeInLeft">
                <div className="about-wrap relative">
                  <div className="about-wrap-inner">
                    <div className="about-wrap-details">
                      <div className="text-center">
                        <div className="about-img">
                          <img
                            src={hospitalAbout.ceo_image}
                            alt="CEO Message"
                            className="ceo-image"
                            style={{
                              width: "100%",
                              height: "auto",
                              objectFit: isMobile ? "contain" : "cover",
                              objectPosition: "top center",
                              borderTopRightRadius: "60px",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6" data-animation="fadeInRight" style={{paddingTop:isMobile ? "0" : "3rem",paddingBottom:isMobile ? "0" : "3rem"}}>
                <div className="title-wrap margin-bottom-20">
                  <div className="section-title">
                    <div className="section-title margin-bottom-40">
                      <h2 className="title text-uppercase mb-0 pt-4">
                        {siteData?.site_type === "hospitals" ? (
                          <>
                            CEO <span className="theme-color">Message</span>
                          </>
                        ) : (
                          <>
                            DOCTOR <span className="theme-color">Message</span>
                          </>
                        )}
                      </h2>
                      <span className="section-border-bottom"></span>
                    </div>
                  </div>
                  <div className="pad-top-5">
                    <div>
                      {/* <span
                        dangerouslySetInnerHTML={createMarkup(displayContent)}
                      /> */}
                      <span
                        dangerouslySetInnerHTML={createMarkup(hospitalAbout?.ceo_description)}
                      />
                    </div>
                  </div>
                </div>
                {/* {shouldTruncate && (
                  <button
                    onClick={() => setExpanded(!expanded)}
                    className="btn btn-default"
                  >
                    {expanded ? "Read Less" : "Read More"}
                  </button>
                )} */}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ClasicAboutCeoMessage;
